import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';

interface AuthLayoutProps {
  children: React.ReactNode;
  role: 'client' | 'expert';
  title: string;
  subtitle?: string;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children, role, title, subtitle }) => {
  const otherRole = role === 'client' ? 'expert' : 'client';
  const otherRoleLabel = role === 'client' ? 'Expert' : 'Client';
  const roleColor = role === 'client' ? 'purple' : 'pink';

  return (
    <div className={`min-h-screen bg-gradient-to-br from-${roleColor}-50 via-${roleColor}-50 to-blue-50 flex items-center justify-center p-4`}>
      <div className="w-full max-w-md">
        {/* Logo/Branding */}
        <div className="text-center mb-8">
          <Link to="/auth/select" className="inline-block">
            <img src={logo} alt="BookDay" className="h-12 w-auto" />
          </Link>
        </div>

        {/* Main Card */}
        <div className="bg-white rounded-2xl shadow-xl p-8">
          {title && <h2 className="text-2xl font-semibold text-gray-900 mb-2">{title}</h2>}
          {subtitle && <p className={`text-sm text-${roleColor}-600 mb-6`}>{subtitle}</p>}
          {!title && !subtitle && <div className="mb-4" />}

          {children}

          {/* Switch Role Link */}
          <div className="mt-6 text-center text-sm text-gray-600">
            Are you a {otherRoleLabel}?{' '}
            <Link
              to={`/${otherRole}/login`}
              className={`text-${roleColor}-600 hover:underline font-medium`}
            >
              Switch to {otherRoleLabel}
            </Link>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-6 text-center text-xs text-gray-500">
          <Link to="/terms" className="hover:underline">
            Terms of Service
          </Link>
          {' · '}
          <Link to="/privacy" className="hover:underline">
            Privacy Policy
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
